<template>
    <div :class="alert_info.classContainer || 'alert-info-box'">
      <!-- Icono o Svg  -->
      <i v-if="alert_info.icon" :class="['fa', alert_info.icon || 'img-alert-info']"></i>
      <img v-if="alert_info.svg" :src="getSvgIcon(alert_info.svg)" alt="svg icon" :class="alert_info.classSvg || 'img-alert-info'" />
      <div>
        <!-- Titulo  -->
        <h4 :class="alert_info.classTitle || 'text-primary'">{{ alert_info.title }}</h4>
        <!-- Text  -->
        <p :class="alert_info.classText || 'text-secondary'">
            <!-- Texto sin enlace -->
            <span v-if="alert_info.text">{{ alert_info.text }}</span>
            <!-- Textos con enlace -->
            <template v-else>
              <span v-for="(part, index) in alert_info.textParts" :key="index">
                <a v-if="part.link" :href="part.link" target="_blank" rel="noopener noreferrer">
                  {{ part.text }}
                </a>
                <span v-else :style="{ fontWeight: part.strong || 'normal' }">
                  {{ part.text }}
                </span>
              </span>
            </template>
        </p>
      </div>
    </div>
</template>
<script>
export default {
  name: 'alert-info-box',
  props: ['alert_info'],
  methods: {
    getSvgIcon (svg) {
      return require(`@/assets/images/svg/${svg}`)
    }
  }
}
</script>
<style>
/* Estilos por defecto para darle forma al componente (No deben ser cambiados) lo mejor es pasar el prop con la clase que se necesite */
.alert-info-box {
  padding: 0.7rem 0.5rem;
  background-color: #E6EEFA;
  border: #D0E2F8 2px solid;
  border-radius: 4px;
  margin-top: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.img-alert-info {
  margin-right: 0.5rem;
}
</style>